import React from "react";

function ModuleNotSubscribed() {
  return (
    <div
      style={{
        background: "#F6F8FA",
        minHeight: "calc(100vh - 84px)",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "16px",
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      <svg
        width="56"
        height="56"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#2965AD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
      <p style={{ fontSize: "16px", fontWeight: 600, color: "#1e293b", margin: 0, textAlign: "center" }}>
        This module is not subscribed.
      </p>
      <p style={{ fontSize: "14px", color: "#64748b", margin: 0, textAlign: "center" }}>
        Please contact the admin for a subscription.
      </p>
    </div>
  );
}

export default ModuleNotSubscribed;
